import { render, staticRenderFns } from "./SyncsSong.vue?vue&type=template&id=241b5953"
import script from "./SyncsSong.vue?vue&type=script&lang=js"
export * from "./SyncsSong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports